import React, { useState, useRef } from 'react';
import { NavMenuMobile } from '../NavMenu';
import styled from 'styled-components/macro';
import { DialogOverlay, DialogContent } from '@reach/dialog';
import '@reach/dialog/styles.css';
import Buscador from '../Buscador';
import CloseIcon from '../svg/close';
import { FiSearch } from 'react-icons/fi';
import { Root, MenuWrapper } from '../Buscador/styles';
import { useTranslate } from '../../contexts/languageContext';
import { responsive } from '../../resources/constantes.json';
import RoundButton from '../Botones/RoundButton';

/**
 * Navegador entre ámbitos para la versión móvil (responsive) del sitio web.
 * Incluye a **Buscador** para buscar entre ámbitos y una serie de drodowns que se revelan
 * según se utiliza el anterior para acceder a ámbitos de disinto nivel.
 */
const BuscadorMobile = ({ nomenclator, eleccion, ambito, page, className }) => {
  const [isOpen, setIsOpen] = useState(false);
  const closeRef = useRef();
  return (
    <BuscadorModal
      isOpen={isOpen}
      setIsOpen={setIsOpen}
      initialFocusRef={closeRef}
      page={page}
      icon={
        <FiSearch style={{ width: '50%', height: '50%' }} />
      }
      className={className}
    >
      <CloseRow>
        <StyledBuscador
          eleccion={eleccion}
          nomenclator={nomenclator}
          page={page}
          onSelect={() => setIsOpen(false)}
          onChangeCallback={() => setIsOpen(false)}
          searchIconColor="#283f5f"
        />
        <CloseButton onClick={() => setIsOpen(false)} ref={closeRef}>
          <CloseIcon
            width={30}
            height={30}
            fill="#ffffff"
            css={`
              vertical-align: top;
            `}
          />
        </CloseButton>
      </CloseRow>
      <StyledNavMenuMobile
        nomenclator={nomenclator}
        eleccion={eleccion}
        ambito={ambito}
        page={page}
        setIsOpen={setIsOpen}
      />
    </BuscadorModal>
  );
};

const BuscadorModal = ({
  className,
  children,
  isOpen,
  setIsOpen,
  icon,
  initialFocusRef,
  page,
}) => {
  const t = useTranslate();
  return (
    <ModalContainer className={className}>
      <RoundButton
        onClick={() => setIsOpen(true)}
        style={{ background: '#215CCC' }}
      >
        {icon}
        <span className="visually-hidden">
          {t('abrirMenuNavegacionPorAmbitos')}
        </span>
      </RoundButton>
      {isOpen && (
        <StyledDialogOverlay
          initialFocusRef={initialFocusRef}
          onDismiss={() => setIsOpen(false)}
          isOpen={isOpen}
        >
          <StyledDialogContent>{children}</StyledDialogContent>
        </StyledDialogOverlay>
      )}
    </ModalContainer>
  );
};

const CloseRow = styled.div`
  display: flex;
  width: 100%;
  justify-content:space-between;
  align-items: center;
  gap:2.5rem;

  @media (max-width: ${469}px) {
    flex-direction :column-reverse;
    align-items: end;
  }
`;

const ModalContainer = styled.div`
  display: flex;
  width: 100%;
  height: 100%;
`;

const StyledDialogOverlay = styled(DialogOverlay)`
  && {
    z-index: 10000;
    padding: 3rem;
  }

  @media (max-width: ${449}px) {
    && {
      z-index: 10000;
      padding: 2rem;
    }  
  }
`;

const StyledDialogContent = styled(DialogContent)`
  && {
    box-sizing: border-box;
    height: 100%;
    margin: 0;
    padding: 0;
    opacity: 1;
    width: 100%;
    display: flex;
    flex-flow: column;
    background-color: #F5F8FD;
    border-radius: 25px;
    overflow: hidden;
    padding: 4rem 3rem;
    box-shadow: 0px 0px 36px -2px rgba(0,0,0,0.75);

    & .focus-visible {
      outline: 2px solid black;
      outline-offset: -2px;
    }

    @media (max-width: ${responsive.maxWidth.mobile}px) {
      padding: 2rem;
    }
  }
`;

const CloseButton = styled.button`
  width: 50px;
  height: 50px;
  padding: 10px;
  background: #215CCC;
  border: none;
  justify-self: flex-end;
  border-radius: 100px;
`;

const StyledBuscador = styled(Buscador)`
  width: 100%;  
  ${Root} {
    width: 100%;
  }
  input{
    border-radius: 100px;
    background: #FFF;
    padding: 1.8rem 2rem;
    ::placeholder {
        color: #222;
      }
      color: #164192;
  }

  & .focus-visible {
    outline: none;
  }

  ${MenuWrapper} {
    width: 100%;
    background: white;
    padding: 1rem;
    overflow: auto;
  }
`;

const StyledNavMenuMobile = styled(NavMenuMobile)`
  overflow:auto;

  @media (max-width: ${responsive.maxWidth.mobile}px) {
    padding: 2rem 0 0 0;
  }
`;
export default BuscadorMobile;
